import { Directive, HostBinding, HostListener, output } from '@angular/core';
  
  @Directive({
    standalone: false,
    selector: '[appDragDrop]'
  })
  export class DragDropDirective {
    @HostBinding('class.fileover') fileOver: boolean = false;
    readonly fileDropped = output<any>();
  
    // Dragover listener
    @HostListener('dragover', ['$event']) onDragOver(evt:any) {
      evt.preventDefault();
      evt.stopPropagation();
      this.fileOver = true;
    }
  
    // Dragleave listener
    @HostListener('dragleave', ['$event']) public onDragLeave(evt:any) {
      evt.preventDefault();
      evt.stopPropagation();
      this.fileOver = false;
    }
  
    // Drop listener
    @HostListener('drop', ['$event']) public ondrop(evt:any) {
      evt.preventDefault();
      evt.stopPropagation();
      this.fileOver = false;
      const files = evt.dataTransfer.files;
      if (files.length > 0) {
        this.fileDropped.emit(files);
      }
    }
  }